import {ConfirmContext} from '@/lib/confirm';
import MessageModalLayout from '@components/overlays/MessageModalLayout';
import React, {useState} from 'react';

interface ConfirmState {
  title: string;
  message: string | React.ReactNode;
  onlyConfirm?: boolean;
  primaryButtonText?: string;
  onClickOK: () => void;
  onClickCancel: () => void;
}

// 모달을 설정하기 위해서는 상태값으로 저장하고 있다.
// 상황에 맞는 상태를 변화하고 context에 추가한후에 컴포넌트를 정의하면 된다.

export default function ConfirmDialog({children}: {children: React.ReactNode}) {
  const [state, setState] = useState<ConfirmState>();
  const [useMessages, setUseMessages] = useState<boolean>(false);

  const getUseMessages = () => {
    return useMessages;
  };

  const setMessages = (status: boolean) => {
    setUseMessages(status);
  };

  const confirm = (
    title?: string,
    message?: string | React.ReactNode,
    onlyConfirm?: boolean,
    primaryButtonText?: string,
  ): Promise<boolean> => {
    return new Promise(resolve => {
      setState({
        title: title ?? '',
        message: message,
        onlyConfirm,
        primaryButtonText,
        onClickOK: () => {
          setState(undefined);
          resolve(true);
        },
        onClickCancel: () => {
          setState(undefined);
          resolve(!!onlyConfirm);
        },
      });
    });
  };

  return (
    <ConfirmContext.Provider
      value={{
        getUseMessages,
        setMessages,
        confirm,
      }}>
      {children}

      {/* 여기에 live-dashboard에 관한 Modal 작성 */}
      {/* 합성컴포넌트 적용 */}
      {/* 도메인에 따라서 매번 정의를 해줘야한다는 부담감 존재 */}

      {state && (
        <MessageModalLayout
          isOpen={true}
          onlyConfirm={state.onlyConfirm}
          title={state.title}
          content={state.message}
          primaryButtonText={state.primaryButtonText}
          primaryButtonOnClick={state.onClickOK}
          secondaryButtonOnClick={state.onClickCancel}
        />
      )}
    </ConfirmContext.Provider>
  );
}
